import React from 'react'

const logo = require('../assets/dan-logo.png')
const imgFischer = require('../assets/Fischer.jpg')
const imgMueller = require('../assets/Mueller.jpg')

export default () => (
  <div>
    <div className="head">
      <div className="container">
        <img src={logo} alt="DAN EV - Dienst am Nächsten" className="logo" />
        <span
          id="global-slogan"
          data-editable="simpletext"
          className="slogan"
          data-global="data-global"
        >
          Nachbarschaftshilfe
          <br />
          von Mensch zu Mensch
        </span>
        <div className="hotline">
          <strong
            id="global-fragen"
            data-editable="simpletext"
            data-global="data-global"
          >
            Sie haben Fragen?
          </strong>
          <br />
          <span
            id="global-phone"
            data-editable="simpletext"
            data-global="data-global"
          >
            0174/3444893
            <br />
          </span>
        </div>
      </div>
    </div>
    <div className="nav">
      <div className="container">
        <ul className="clearfix">
          <li>
            <a href="/home">Startseite</a>
          </li>
          <li className="active">
            <a href="/geschichte" className="active">
              Über Uns
            </a>
          </li>
          <li>
            <a href="/dienstleistungen">Dienstleistungen</a>
          </li>
          <li>
            <a href="/sie-wollen-helfen">Sie wollen helfen?</a>
          </li>
          <li>
            <a href="/mitglieder">Mitglieder</a>
          </li>
          <li>
            <a href="/kontakt">Kontakt</a>
          </li>
        </ul>
      </div>
    </div>
    <div className="content">
      <div className="container">
        <h1 id="geschichte" data-editable="simpletext" className="mb1">
          Geschichte
        </h1>
        <p id="geschichte-p" data-editable="text">
          Dienst am Nächsten e. V. wurde im Mai 2008 von Edith Scheffold und
          Wolfgang Seibold unter Mithilfe von Sandra und Andreas Baier
          gegründet. Sie machten sich zum Ziel, niederschwellige und
          unbürokratische Hilfen für Seniorinnen und Senioren anzubieten. Als
          zentrales Angebot entstand die Nachbarschaftshilfe. Aufgrund des
          Ausscheidens der langjährigen Verwaltungskraft stand DAN 2019 vor der
          Herausforderung, die administrativen Notwendigkeiten einer großen
          Nachbarschaftshilfe zu bewältigen. Die Vorstände einigten sich
          schließlich auf die Übergabe der Trägerschaft der Nachbarschaftshilfe
          an die Paul Wilhelm von Keppler-Stiftung. Seit 1. Januar 2020
          organisiert somit die Katholische Sozialstation Ulm, als Einrichtung
          der Keppler-Stiftung, die Nachbarschaftshilfe DAN sowie den
          Café-Betrieb im Seniorenzentrum Clarissenhof.
        </p>
        <p>
          <br />
        </p>
        <p id="vorstand" data-editable="text">
          Unser Vereinsvorstand setzt sich zusammen aus:
        </p>
        <div id="table" data-editable="text">
          <table cellPadding={1} cellSpacing={0} style={{ width: 413 }}>
            <tbody>
              <tr>
                <td>Gerhard Fischer</td>
                <td>- Vorstandsvorsitzender</td>
              </tr>
              <tr>
                <td>Armin Müller</td>
                <td>- 2. Vorstand</td>
              </tr>
              <tr>
                <td>Andreas Baier</td>
                <td>- Geschäftsführer</td>
              </tr>
              <tr>
                <td>Sandra Baier</td>
                <td>- Schriftführerin</td>
              </tr>
              <tr>
                <td>August Kneer</td>
                <td>- Beisitzer</td>
              </tr>
              <tr>
                <td>Reinhold Eichhorn</td>
                <td>- Beisitzer</td>
              </tr>
              <tr>
                <td>Walter Feucht</td>
                <td>- Beisitzer</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>
        </div>

        <section className="vorstanede">
          <div className="row">
            <div className="col-md-4">
              <img
                src={imgFischer}
                alt="Fischer.JPG"
                id="vorstand-img-2"
                data-editable="image"
                className="ccm-image-block"
                height={300}
              />
              <p
                id="vorstand-p-2"
                data-editable="simpletext"
                className="mt1 text-center"
              >
                Gerhard Fischer
              </p>
            </div>
            <div className="col-md-4">
              <img
                src={imgMueller}
                alt
                id="vorstand-img-3"
                data-editable="image"
                className="ccm-image-block"
                height={300}
              />
              <p
                id="vorstand-p-3"
                data-editable="simpletext"
                className="mt1 text-center"
              >
                Armin Müller
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/geschichte.js